// extracted by mini-css-extract-plugin
export default {"successIcon":"EnrolledSuccessfully_successIcon__KHaDt","scale":"EnrolledSuccessfully_scale__Nremh"};